import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Sprint 11.3: init Sentry BEFORE rendering React so errors during the
// initial mount are captured. No-op when VITE_SENTRY_DSN_FRONTEND is unset.
import { initSentry } from './sentry';
initSentry();
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
